import {
  DrawerOverlay,
  useDrawerInstance,
  DestroyFormGuard,
  DestroyFormGuardProps,
} from '@cast/design-system';

type Props = DestroyFormGuardProps & { testId?: string };

export const DestroyDrawerFormGuard = ({
  testId = 'destroy-drawer-form-guard',
  ...props
}: Props) => {
  const { shouldRenderGuard, setShouldRenderGuard, close } =
    useDrawerInstance();
  if (!shouldRenderGuard) {
    return null;
  }
  return (
    <DrawerOverlay testId={testId}>
      <DestroyFormGuard
        onContinue={() => setShouldRenderGuard(false)}
        onLeave={close}
        {...props}
      />
    </DrawerOverlay>
  );
};
